import { Box, Tooltip, Zoom } from "@mui/material"
import Icon from "../../Icon/Icon";

/**
 * Help Icon for show information with a tooltip
 * @param {Object} param0
 * @param {String} param0.text label for tooltip
 * @param {String} param0.size  Size of icon container
 * @param {String} param0.placement Tooltip position  ['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start','top']
 * @param {('question' | 'info' | 'check')} param0.type Type of icon
 * @param {String} param0.color Color of icon
 * @param {String} param0.backgroundColor Background color of icon
 * @param {Object} param0.sx Style of icon container
 * @param {Object} param0.rest Rest of props
 * @returns {HTMLElement}
 */
export const HelpIcon = ({
  text="",
  size="small",
  placement = "top",
  sx = {},
  type = "question",
  color="#8AA1AC",
  backgroundColor="linear-gradient(to bottom, #F9FBFD, #D7DEE3)",
  ...rest
}) => {

  const iconName = () => {
    if (type === "info") return "outline_info_mark";
    if (type === "check") return "check_icon";
    return "question_mark"
  }

  const iconSize = () => {
    if (type === "info" || type === "check") return 16;
    return 10
  }

  const getSize = () => {
    return 16;
  }

  return (
    <Tooltip
      title={text}
      placement={placement}
      arrow
      TransitionComponent={Zoom}
      TransitionProps={{ timeout: 150 }}
    >
        <Box
          sx={{
            borderRadius: "50%",
            background: backgroundColor,
            display: "grid",
            placeContent: "center",
            maxHeight: getSize(),
            maxWidth: getSize(),
            minHeight: getSize(),
            minWidth: getSize(),
            ...sx
          }}
          {...rest}
        >
          <Box
            sx={{
              display: "grid",
              placeContent: "center",
            }}
          >
            <Icon name={iconName()} size={iconSize()} color={color} />
        </Box>
      </Box>
    </Tooltip>
  )
}
